export default __webpack_public_path__ + "static/media/folio-icon.45a120c3.svg";